export default __webpack_public_path__ + "static/coach-9d20228c0d4b63f7d2d3af6d13fd71f6.svg";